import { ColumnType } from "antd/es/table";
import { FilterValue } from "antd/es/table/interface";
import { getEnumValueByStringValue } from "utils/types";
import { FilterIcon } from "assets/icons";

import { EnumFilterInput } from "./types";

export const getColumnEnumFilterProps = <T, D extends keyof T & string, TEnum>(
  _dataIndex: D,
  filteredValue: FilterValue | null | undefined,
  filterMultiple: boolean,
  enumObj: TEnum
): ColumnType<T> => ({
  filteredValue: filteredValue || null,
  filterMultiple,
  filterIcon: ($filtered: boolean) => <FilterIcon {...{ $filtered }} />,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Object.entries(enumObj as any)
    .filter(([key]) => Number.isNaN(Number(key)))
    .map(([value]) => ({
      value,
      text: value,
    })),
});

export const getEnumFilterValue = <TPath extends string, TEnum>(
  value: FilterValue | undefined | null,
  path: TPath,
  enumObj: TEnum
): EnumFilterInput<TEnum> => {
  if (!value?.length) {
    return {};
  }

  const values = value
    .map((filterValue) =>
      typeof filterValue === "string"
        ? getEnumValueByStringValue(enumObj, filterValue)
        : undefined
    )
    .filter((filterValue): filterValue is TEnum[keyof TEnum] => !!filterValue);

  if (!values.length) {
    return {};
  }

  return {
    [path]: { in: values },
  };
};
